export default {"src":"/_next/static/image/public/images/ic_plus_purple.82b17f65f42e527b57cf32bd0d725da4.svg","height":14,"width":14};